import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { IGetStudentAttend, IStudent, IStudentAttend, IStudentAttendChange } from '../../../models/students.model';
import Loader from '../../Loader';
import StudentName from './Name';
import Pagination from '../../Pagination';

import { Table, TableColumnsType } from 'antd';

import useAxios from '../../../hooks/useAxios';
import { getStudentAttend } from '../../../api/students.api';
import ErrorResponse from '../../ErrorResponse';
import config from '../../../lib/config';
import moment from 'moment';
import { getCommonCodeLabel } from '../../../lib/store';
import Button from '../../Button';
import { StudentContents } from '../../../pages/student/student';
import ChangeAttendanceModal from './modals/ChangeAttendanceModal';
import SelectStudentClass from './SelectStudentClass';
import { PAYMENT_EDIT_HQ_MANAGER } from '../../../constans';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store/rootReducer';
import ConfirmModal from '../../modals/ConfirmModal';
import { submitAbsenceRefundResotre } from '../../../api/refunds.api';
import useNotification from '../../../hooks/useNotification';
import { IResponse } from '../../../models/common.api.model';

interface IProps {
  student: IStudent | undefined;
  setTabIndex: (tabIndex: number) => void;
}

const StudentAttendance: FC<IProps> = ({
  student,
  setTabIndex,
}) => {
  const { data: res, isLoading, error, execute } = useAxios<IGetStudentAttend>();
  const { data: restoreRes, isLoading: restoreIsLoading, error: restoreError, execute: executeRestore } = useAxios<IResponse<any>>();
  const [page, setPage] = useState(1);
  const { t } = useTranslation();
  const [visibleAttChange, setVisibleAttChange] = useState(false);
  const [attChangeValues, setAttChangeValues] = useState<IStudentAttendChange>();
  const [classCode, setClassCode] = useState<string>();
  const {auth} = useSelector((state: RootState) => state.auth);
  const {serverDate} = useSelector((state: RootState) => state.serverDate);
  const [confirmAdminRestoreVisible, setConfirmAdminRestoreVisible] = useState(false);
  const [attendCode, setAttendCode] = useState<number>();
  const { successNotification } = useNotification();

  useEffect(() => {
    fnReload();
  }, [student, classCode]);

  useEffect(() => {
    if(restoreRes) {
        if(restoreRes.result === "success") {
          successNotification(t('복구되었습니다.'));
          fnReload();
        }
    }
}, [restoreRes]);

  const fnReload = () => {
    if (student && classCode) {
      execute(getStudentAttend(student.studentCode, student.campusCode, classCode));
    }

    if (student && !classCode) {
      execute(getStudentAttend(student.studentCode, student.campusCode, null));
    }
  }

  const isRefundDisabled = () => {
    if (!res) return true;
    //console.log('res', res);
    return !res.data.some(item => item.attendStatus === 'NT' && item.refundYn === 'N');
  }

  const onRefund = () => {
    const classStudentCode = res?.data?.find(item => item.attendStatus === 'NT' && item.refundYn === 'N')?.classStudentCode;
    if (classStudentCode) {
      sessionStorage.setItem('memberKorName', student?.studentKorName || '');
      sessionStorage.setItem('memberEngName', student?.studentEngName || '');
      sessionStorage.setItem('classStudentCode', String(classStudentCode));
      setTabIndex(StudentContents.AttendanceRefund);
    }
  }

  const onAttChange = (record:IStudentAttend) => {
    setAttChangeValues({
      attendCode: record.attendCode,
      timetableCode: record.timetableCode,
      timetableDate: record.timetableDate,
      classStudentCode: record.classStudentCode,
      attendStatus: record.attendStatus,
      classCode: record.classCode,
      className: record.className,
      memo: record.memo
    });
    
    if(record.timetableCode) {
      setVisibleAttChange(true);
    }
  }

  const onAdminRestoreButton = () => {
    setConfirmAdminRestoreVisible(false);
    setAttendCode(undefined);

    //파라미터 셋팅(form)
    if(attendCode) {
      executeRestore(submitAbsenceRefundResotre(attendCode));
    }
    else {
      console.log(t('인정결석 환불 재처리 오류'));
    }
  }

  const columns: TableColumnsType<IStudentAttend> = [
    {
      title: t('common.column.date'),
      dataIndex: 'timetableDate',
      render: (value, record) => {
        return(
          <div className='click-link' onClick={()=>onAttChange(record)}>
            {moment(value).format('YYYY.MM.DD')}
          </div>
        );
      },
    },
    {
      title: t('student.student.column18'),
      dataIndex: 'timetableDate',
      render: value => moment(value).format('ddd'),
    },
    {
      title: t('common.menu.class'),
      dataIndex: 'className',
    },
    {
      title: t('student.student.tab8'),
      dataIndex: 'attendStatus',
      render: value => getCommonCodeLabel('CL0001', value, 'ko'),
    },
    {
      title: t('common.text.note'),
      dataIndex: 'memo',
    },
    {
      title: t('student.student.column111'),
      dataIndex: 'attachFileCode',
      render: (value, record) => {
        if (value) {
          return (
            <a
              className="download-link"
              href={`${record.attachFile.fileLocation}`}
              download={record.attachFile.originalName}
            >
              {record.attachFile.originalName}
            </a>
          );
        }
        return null;
      },
    },
    {
      title: t('student.student.button21'),
      dataIndex: 'refundYn',
      key: 'refundYn',
      width: 90,
      render: (value, record) => {
        if (record.attendStatus === 'NT') {
          if (value === 'N') return value;
          const isBusinessTeamManager = PAYMENT_EDIT_HQ_MANAGER.includes(auth.groupNo);
          const isRefundPossibleDate = moment(serverDate).subtract("90", 'd').isBefore(moment(record.timetableDate));
          if (!isBusinessTeamManager || !isRefundPossibleDate) return value;
          return (
            <div className="comm-btn__area justify-content-center">
              <span className='d-flex align-items-center'>
                {value}
              </span>
              <Button
                className="btn-basic mint small"
                onClick={() => {
                  setAttendCode(record.attendCode);
                  setConfirmAdminRestoreVisible(true);
                }}
                text={t('복구')}
                disabled={record.attendStatus !== 'NT' || !record.lastUpdDttm}
                //writeAuthYn={writeAuthYn}
              />
            </div>
          )
        }
        return '';
      },
    },
  ];

  return (
    <>
      {isLoading ? <Loader /> : null}
      <ErrorResponse error={error} />
      <ErrorResponse error={restoreError} />
      <StudentName student={student} />

      <div className="comm-btn__area right mt-3">
        <div style={{ width: '220px' }}>
          <SelectStudentClass
            memberCode={student?.studentCode}
            classCode={classCode}
            setClassCode={setClassCode}
          />
        </div>
      </div>
      <div>
        <Table
          className='comm-table__area mt-3'
          columns={columns}
          dataSource={res?.data}
          pagination={{
            current: page,
            pageSize: config.pageSize,
          }}
        />
      </div>
      <div className="comm-bx__between">
        <div />
        <div className="common-paging center">
          <Pagination
            count={res?.data?.length || 0}
            page={page}
            setPage={setPage}
          />          
        </div>
        <div className="comm-btn__area right">
          <Button
            className="btn-basic pink-line"
            onClick={onRefund}
            text={t('student.student.button22')}
            disabled={isRefundDisabled()}
          />
        </div>
      </div>

      {visibleAttChange && attChangeValues && 
        <ChangeAttendanceModal
          visible={visibleAttChange}
          setVisible={setVisibleAttChange}
          attChangeValues={attChangeValues}
          student={student}
          fnReload={fnReload}
        />
      }

      {confirmAdminRestoreVisible && (
          <ConfirmModal
          visible={confirmAdminRestoreVisible}
          setVisible={setConfirmAdminRestoreVisible}
          onConfirm={onAdminRestoreButton}
          titleText={t('인정결석 환불 복구')}
          messageText={t('인정결석 환불항목을 복구 하시겠습니까?')}
          confirmText={t('복구')}
          cancelText={t('common.button.cancel')}
          />
      )}
    </>
  );
};

export default StudentAttendance;
